import * as React from 'react';
import styled from 'styled-components';
import Colours from '../State/Colours';
import Context from '../State/Context';
import devices from '../State/Devices';
import PageNavigationFooter from './PageNavigationFooter';
import IndustrialAndCommercial from './Pages/IndustrialAndCommercial';
import LicensedWaterUse from './Pages/LicensedWaterUse';
import PropertyLocation from './Pages/PropertyLocation';
import TotalWaterUse from './Pages/TotalWaterUse';
import UnlicensedWaterUse from './Pages/UnlicensedWaterUse';
import ProgressBar from './ProgressBar';

const ContentPanel = styled.div`
    -ms-grid-column: 2;
    padding: 40px 60px;
    background-color: ${Colours.mainPanelBackground};
    overflow: scroll;
    overflow-x: hidden;

    hr {
        margin: 32px 0;
        border-style: solid;
    }

    hr.green {
        border-color: ${Colours.primary};
    }

    hr.gray {
        border-color: ${Colours.panelBackground};
    }
    
    hr.purple {
        border-color: ${Colours.secondary};
    }

    @media ${devices.laptop} {
        box-sizing: border-box;
        padding: 20px 20px 0 20px;
    }
`;

export default () => (
    <Context.Consumer>
    {({ page }) => (
        <ContentPanel className="ContentPanel">
            <ProgressBar/>
            {page === 1 && <PropertyLocation />}
            {page === 2 && <UnlicensedWaterUse />}
            {page === 3 && <LicensedWaterUse />}
            {page === 4 && <IndustrialAndCommercial />}
            {page === 5 && <TotalWaterUse />}
            <PageNavigationFooter />
        </ContentPanel>
    )}
    </Context.Consumer>
);


// WEBPACK FOOTER //
// ./src/Components/MainContentPanel.tsx